import angular from "angular"
import React from "react"
import { react2angular } from "react2angular"
import ListBox from "@paprika/list-box"
import Button from "@paprika/button"
import "./markerSelector.scss"

function MarkerSelector(props) {
  const refListBox = React.useRef(null)

  const pitchMarkers = React.useMemo(() => props.markers.filter((marker) => marker.type !== "facility"), [
    props.markers,
  ])
  const facilityMarkers = React.useMemo(() => props.markers.filter((marker) => marker.type === "facility"), [
    props.markers,
  ])

  const selectedMarkerIndex = props.markers.findIndex(
    (marker) => props.selectedMarker?.options.urlstringid === marker.urlstringid
  )

  const renderPitchMarkers = () => pitchMarkers.map((marker) => renderMarkerOption(marker, true))

  const renderFacilityMarkers = () => facilityMarkers.map((marker) => renderMarkerOption(marker))

  const renderMarkerOption = (marker, isShowingAreaLabel = false) => (
    <ListBox.Option
      isSelected={props.selectedMarker?.options.urlstringid === marker.urlstringid}
      key={marker?._id || marker?.urlstringid}
    >
      {`${marker.name} ${isShowingAreaLabel && marker.area && props.pitchNumberByArea ? `- ${marker.area}` : ""}`}
    </ListBox.Option>
  )

  const isNavButtonsShowing = selectedMarkerIndex !== -1

  return (
    <div className="markers-selector">
      <ListBox
        className={`markers-selector-list-box ${isNavButtonsShowing ? "nav-showing" : ""}`}
        onChange={props.onChange}
        ref={refListBox}
      >
        <ListBox.Trigger
          placeholder="Browse..."
          onClickClear={() => {
            refListBox.current.clear()
          }}
        />
        <ListBox.Filter />
        {renderFacilityMarkers()}
        {renderPitchMarkers()}
      </ListBox>
      {isNavButtonsShowing ? (
        <div className="nav-buttons">
          <Button
            kind={Button.types.kind.FLAT}
            className="nav-buttons__button"
            onClick={() => {
              selectedMarkerIndex >= 0 && props.onChange(selectedMarkerIndex - 1)
            }}
          >
            <i className="fa fa-caret-left" />
          </Button>
          <Button
            kind={Button.types.kind.FLAT}
            className="nav-buttons__button"
            onClick={() => {
              selectedMarkerIndex < props.markers.length - 1 && props.onChange(selectedMarkerIndex + 1)
            }}
          >
            <i className="fa fa-caret-right" />
          </Button>
        </div>
      ) : null}
    </div>
  )
}

export default angular
  .module("makeamapAngularApp.markerselector", [])
  .component(
    "markerselector",
    react2angular(MarkerSelector, ["pitchNumberByArea", "selectedMarker", "onChange", "markers"])
  ).name
